<div class="login-register">
  <div class="login-register-box error-card text-center">
    <h1>404</h1>
    <h3 class="text-uppercase">Página não encontrada!</h3>
    <p class="text-muted m-t-30 m-b-30">
      Talvez você esteja querendo voltar para a tela de Administração
    </p>
    <a
      mat-raised-button
      color="primary"
      [routerLink]="['/admin']"
      class="btn btn-info btn-rounded waves-effect waves-light m-b-40"
      >Voltar para Administração</a
    >
  </div>
</div>
